import React from "react";
const IconInfo = ({
  className
}) => {
  return /*#__PURE__*/React.createElement("svg", {
    className: className,
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "21",
    viewBox: "0 0 24 21"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#00315C",
    d: "M22.967 9.39l-4.66-8.326c-.34-.61-.974-.986-1.66-.986H7.353c-.687 0-1.32.376-1.662.986l-4.66 8.334c-.337.603-.337 1.345 0 1.948l4.66 8.318c.341.61.975.985 1.661.985h9.293c.687 0 1.32-.376 1.662-.985l4.66-8.326c.337-.604.337-1.345 0-1.949z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    fillRule: "nonzero",
    d: "M11.142 7.127c-.1 0-.182-.034-.246-.103-.064-.068-.096-.152-.096-.253V5.5c0-.1.034-.185.103-.254.068-.068.148-.102.24-.102h1.71c.1 0 .184.034.253.102.068.069.102.153.102.254V6.77c0 .1-.034.185-.102.253-.069.069-.153.103-.253.103h-1.71zm0 8.101c-.091 0-.17-.034-.24-.103-.068-.068-.102-.148-.102-.24v-6.43c0-.101.034-.183.103-.247.068-.064.148-.096.24-.096h1.71c.1 0 .184.032.253.096.068.064.102.146.102.246v6.432c0 .1-.034.182-.102.246-.069.064-.153.096-.253.096h-1.71z"
  })));
};
export default IconInfo;